import { CssProperty, CssRule, CssStylesheet } from '@portal-core/project-files/stylesheets/models/css-stylesheet.model';

export class ComputedStylesheet {
  cssRules: CssRule[];
  cssStylesheets: CssStylesheet[] = [];
  medium: string | null;
  styles: Dictionary<ComputedStyle> = {};
}

export class ComputedStyle {
  comment: string = null;
  isHidden: boolean = false;
  isResponsiveGridTemplateStyle: boolean = false;
  name: string = null;
  properties: Dictionary<CssProperty> = {};
}
